import type { ModalProps } from '@/components/providers/ModalProvider/ModalProvider';
import type { Party } from '@/features/party/types';

import type { CRM } from '../../types';

import ExportEmailModalAnva from './ExportEmailModalAnva';
import ExportEmailModalAssu from './ExportEmailModalAssu';
import ExportEmailModalBrio from './ExportEmailModalBrio';
import ExportEmailModalDias from './ExportEmailModalDias';
import type {
  ExportEmailValuesAnva,
  ExportEmailValuesAssu,
  ExportEmailValuesBrio,
  ExportEmailValuesDias,
} from './types';

type Props = ModalProps & {
  crm: CRM;
  defaultValues?: Partial<
    ExportEmailValuesAnva &
      ExportEmailValuesDias &
      ExportEmailValuesAssu &
      Omit<ExportEmailValuesBrio, 'priority'>
  >;
  party: Maybe<Party>;
};

export default function ExportEmailModal({
  onClose,
  crm,
  defaultValues,
  party,
}: Props) {
  switch (crm) {
    case 'anva':
      return (
        <ExportEmailModalAnva
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );
    case 'dias':
      return (
        <ExportEmailModalDias
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );
    case 'assu':
      return (
        <ExportEmailModalAssu
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );
    case 'brio':
      return (
        <ExportEmailModalBrio
          onClose={onClose}
          party={party}
          defaultValues={defaultValues}
        />
      );

    default:
      return null;
  }
}
